import type { FlattenSimpleInterpolation } from 'styled-components'
import { createGlobalStyle, css } from 'styled-components'

import { typography } from '@vfuk/core-mixins'

import type { StylesProps } from './styles.types'

import fontFace from './partials/fontFace'
import normalize from './partials/normalize'
import fontSizes from './partials/fontSizes'
import formElementSuggestions from './partials/formElementSuggestions'

// stylelint-disable property-no-vendor-prefix

const styles = createGlobalStyle(
  (props: StylesProps): FlattenSimpleInterpolation => css`
    ${normalize}

    html {
      font-family: sans-serif;
      box-sizing: border-box;
      /* stylelint-disable-line */
      -ms-text-size-adjust: 100%;
      -ms-overflow-style: scrollbar;
      /* -webkit-tap-highlight-color: rgba($color-black, 0); */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    body {
      ${typography.paragraph(2, false)}
      font-family: ${props.theme.baseFont.fontFamily};
      font-weight: ${props.theme.baseFont.fontWeight};
      color: ${props.theme.baseFont.color};
      background-color: ${props.theme.baseFont.backgroundColor};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: left;
    }

    ::-webkit-input-placeholder,
    ::-moz-placeholder,
    :-ms-input-placeholder {
      color: ${props.theme.color.monochrome4.default};
      font-weight: 400;
    }

    ${fontFace}
    ${fontSizes}
    ${formElementSuggestions}
  `,
)

export default styles
